import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export const Layout = () => {
    const location = useLocation();

    useEffect(() => {
        if (!location.hash) {
            window.scrollTo({ top: 0, behavior: "auto" });
        }
    }, [location.pathname, location.hash]);

    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Header />
            <main className="flex-1 pt-24 md:pt-32" data-testid="main-content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
